var map = {
	"./SHS-ASURION/faqs.json": 3412,
	"./SHS-SPRINT/faqs.json": 3413,
	"./SHS-WEB/faqs.json": 3414,
	"./TCH-WEB/faqs.json": 3415
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3411;


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/faqpage/resources/data ^\.\/.*\/faqs\.json$
// module id = 3411
// module chunks = 0